/**
 * @file
 * Custom JS behaviour for slides homepage.
 */

(function ($) {

  Drupal.behaviors.slideshomepage = {
    attach: function (context, settings) {
      // Slides homepage behaviors.
      if ($('.view-slides-homepage').length > 0) {
        $('.slick--view--slides-homepage').on('init', function (event, slick) {
          $('.field--name-field-slide-tag').each(function (index) {
            $('.view-slides-homepage .slick-dots button').eq(index).text($(this).text());
          });
        });
      }
    }
  };

})(jQuery);
